/* ==========================================================================
   The Rich Beard · Ficha de producto
   Galería, cantidad, opción de compra, variantes, añadir al carrito (con el
   cajón del tema), compra exprés, barra fija móvil, barra de envío gratis y
   acordeones. Port del comportamiento de ProductBuyBox.tsx, Gallery.tsx y
   Accordion.tsx de la vista previa.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Dinero con dos decimales, como money() de la vista previa ($30.00) */
  function money(cents, fmt) {
    cents = parseInt(cents, 10) || 0;
    fmt = fmt || '${{amount}}';
    function num(n, dec, th, dc) {
      var p = (n / 100).toFixed(dec).split('.');
      var ent = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return ent + (p[1] ? dc + p[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var tipo = m ? m[1] : 'amount', val;
    switch (tipo) {
      case 'amount_no_decimals': val = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = num(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = num(cents, 2, ' ', ','); break;
      default: val = num(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  /* --- Acordeones: uno abierto por grupo, como Accordion.tsx ----------- */
  function initAccordions(scope) {
    scope.querySelectorAll('[data-trb-acc]').forEach(function (acc) {
      if (acc.dataset.ready) return;
      acc.dataset.ready = '1';
      acc.addEventListener('click', function (e) {
        var btn = e.target.closest('.trb-pdp-acc__btn');
        if (!btn || !acc.contains(btn)) return;
        var abrir = btn.getAttribute('aria-expanded') !== 'true';
        acc.querySelectorAll('.trb-pdp-acc__btn').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(b.getAttribute('aria-controls'));
          if (p) p.dataset.open = 'false';
        });
        if (abrir) {
          btn.setAttribute('aria-expanded', 'true');
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel) panel.dataset.open = 'true';
        }
      });
    });
  }

  /* --- Tomas de modelo: si no queda ninguna, entran las genéricas ------- */
  function initLifestyle(scope) {
    scope.querySelectorAll('[data-trb-life]').forEach(function (grid) {
      var check = function () {
        if (grid.querySelector('figure')) return;
        var tpl = grid.parentNode.querySelector('[data-trb-life-fallback]');
        if (tpl && tpl.content) grid.appendChild(tpl.content.cloneNode(true));
        if (!grid.querySelector('figure')) grid.closest('.trb-pdp').hidden = true;
      };
      grid.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('error', function () { setTimeout(check, 0); });
      });
      if (!grid.querySelector('figure')) check();
    });
  }

  /* --- Caja de compra ------------------------------------------------- */
  function initBuyBox(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var fmt = el.dataset.moneyFormat;
    var form = el.querySelector('[data-trb-form]');
    if (!form) return;
    var variantInput = form.querySelector('[data-variant-input]');
    var planInput = form.querySelector('[data-plan-input]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var atc = form.querySelector('[data-atc]');
    var atcLabel = form.querySelector('[data-atc-label]');
    var express = form.querySelector('[data-express]');
    var priceEl = el.querySelector('[data-price]');
    var compareEl = el.querySelector('[data-compare]');
    var stickyPrice = el.querySelector('[data-sticky-price]');
    var stickyAdd = el.querySelector('[data-sticky-add]');
    var variantsEl = form.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
    var variant = variants ? variants.filter(function (v) { return String(v.id) === variantInput.value; })[0] : null;

    var state = {
      price: parseInt(el.dataset.basePrice, 10) || 0,
      compare: parseInt(el.dataset.baseCompare, 10) || null,
      available: atc ? !atc.disabled : true,
      planPrice: null
    };

    /* Galería */
    var gal = el.querySelector('[data-trb-gallery]');
    if (gal) {
      var main = gal.querySelector('.trb-pdp-gal__main img');
      gal.addEventListener('click', function (e) {
        var t = e.target.closest('.trb-pdp-gal__thumb');
        if (!t || !main) return;
        gal.querySelectorAll('.trb-pdp-gal__thumb').forEach(function (b) {
          b.classList.toggle('is-active', b === t);
          b.setAttribute('aria-current', b === t ? 'true' : 'false');
        });
        main.classList.remove('is-in');
        void main.offsetWidth;
        main.src = t.dataset.src;
        main.classList.add('is-in');
      });
    }

    function qty() { return Math.max(1, Math.min(10, parseInt(qtyInput && qtyInput.value, 10) || 1)); }

    function render() {
      var unit = state.planPrice != null ? state.planPrice : state.price;
      if (unit == null) return;
      if (priceEl) priceEl.textContent = money(unit, fmt);
      if (compareEl) {
        var tachado = null;
        if (state.planPrice != null && state.planPrice < state.price) tachado = state.price;
        else if (state.planPrice == null && state.compare && state.compare > state.price) tachado = state.compare;
        compareEl.hidden = !tachado;
        if (tachado) compareEl.textContent = money(tachado, fmt);
      }
      // Kit con una pieza agotada (data-kit-out): siempre agotado, aunque cambie el plan o la variante.
      if (atc && atc.hasAttribute('data-kit-out')) state.available = false;
      if (atcLabel) atcLabel.textContent = state.available ? 'Add to cart · ' + money(unit * qty(), fmt) : 'Sold out';
      if (atc) atc.disabled = !state.available;
      if (express) express.disabled = !state.available;
      if (stickyAdd) stickyAdd.disabled = !state.available;
      if (stickyPrice) stickyPrice.textContent = money(unit * qty(), fmt);
    }

    /* Cantidad */
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, Math.min(10, qty() + parseInt(b.dataset.qty, 10)));
        render();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });

    /* Opción de compra */
    form.querySelectorAll('[data-plan-radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        form.querySelectorAll('.trb-pdp-plan__opt').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
        if (planInput) { planInput.value = r.value; planInput.disabled = !r.value; }
        state.planPrice = r.value ? parseInt(r.dataset.planPrice, 10) : null;
        render();
      });
      if (r.checked && r.value) {
        if (planInput) { planInput.value = r.value; planInput.disabled = !r.value; }
        state.planPrice = parseInt(r.dataset.planPrice, 10);
      }
    });

    /* Variantes */
    if (variants) {
      var sels = form.querySelectorAll('[data-option-index]');
      var pick = function () {
        var opts = Array.prototype.map.call(sels, function (s) { return s.value; });
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        })[0];
        if (!v) { state.available = false; render(); return; }
        variant = v;
        variantInput.value = v.id;
        state.price = v.price;
        state.compare = v.compare_at_price;
        state.available = v.available;
        if (v.featured_media && v.featured_media.preview_image && gal) {
          var m = gal.querySelector('.trb-pdp-gal__main img');
          if (m) m.src = v.featured_media.preview_image.src;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        render();
      };
      sels.forEach(function (s) { s.addEventListener('change', pick); });
      if (variant) { state.price = variant.price; state.compare = variant.compare_at_price; state.available = variant.available; }
    }

    /* Añadir al carrito por AJAX y abrir el cajón del tema */
    function add(goCheckout, btn) {
      if (!state.available) return;
      var item = { id: parseInt(variantInput.value, 10), quantity: qty() };
      if (planInput && planInput.value) item.selling_plan = parseInt(planInput.value, 10);
      var drawer = document.getElementById('CartDrawer');
      var sec = drawer ? drawer.closest('.shopify-section') : null;
      var body = { items: [item] };
      if (sec && !goCheckout) body.sections = sec.id.replace('shopify-section-', '');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch(root + 'cart/add.js?skip_sync=1', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); })
        .then(function (res) {
          if (goCheckout) { window.location.href = root + 'checkout'; return; }
          if (window.refreshCartPageContent) window.refreshCartPageContent();
          else if (window.refreshCartDrawer) window.refreshCartDrawer(true, res);
          else window.location.href = root + 'cart';
          refreshFreeShip(el);
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
          if (window.showToast) window.showToast(msg); else alert(msg);
        })
        .finally(function () {
          if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = !state.available; }
        });
    }

    form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      e.preventDefault();
      add(!!(sub && sub.hasAttribute('data-express')), sub || atc);
    });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { add(false, stickyAdd); });

    /* Barra fija móvil: aparece cuando el sentinela sale de pantalla */
    var sentinel = el.querySelector('[data-sentinel]');
    var sticky = el.querySelector('[data-sticky]');
    if (sentinel && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var on = !entries[0].isIntersecting;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = on ? 0 : -1;
      }, { threshold: 0 }).observe(sentinel);
    }

    render();
  }

  /* --- Envío gratis: se recalcula con el carrito real ------------------ */
  function refreshFreeShip(el) {
    var box = el.querySelector('[data-free-ship]');
    if (!box) return;
    var umbral = parseInt(el.dataset.freeThreshold, 10) || 0;
    var fmt = el.dataset.moneyFormat;
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        box.hidden = total === 0;
        var falta = umbral - total;
        var prog = umbral > 0 ? Math.min(1, total / umbral) : 1;
        var msg = box.querySelector('[data-free-ship-msg]');
        var fill = box.querySelector('[data-free-ship-fill]');
        var link = box.querySelector('[data-free-ship-link]');
        if (msg) msg.innerHTML = falta <= 0
          ? '<span class="trb-pdp-ship__ok">Free shipping unlocked.</span>'
          : '<strong>' + money(falta, fmt) + '</strong> away from free ' + (el.dataset.freeIntl ? 'international ' : '') + 'shipping';
        if (fill) { fill.style.width = Math.max(4, prog * 100) + '%'; fill.classList.toggle('is-ok', falta <= 0); }
        if (link) link.hidden = falta <= 0;
      })
      .catch(function () {});
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-trb-pdp]').forEach(initBuyBox);
    initAccordions(scope);
    initLifestyle(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
